<app-card [isHeader]=true [title]="'add_fournisseur'|translate">

    <mat-card-content>
        <mat-vertical-stepper [linear]="false" [selectedIndex]="currentStep" class="mat-elevation-z0">
            <mat-step [completed]=" checkFormVaidity()" [stepControl]="step1.form">
                <ng-template matStepLabel>{{
                    "general_information" | translate
                    }}</ng-template>
                <app-add-information-generale-fournisseur
                    #step1
                    (add)="onAdd()"

                ></app-add-information-generale-fournisseur>
            </mat-step>

            <mat-step [stepControl]="step2.form"
            ><!--[stepControl]="step2.form" -->
                <ng-template matStepLabel>{{
                    "Informations sur le premier responsable" | translate
                    }}</ng-template>

                <!--  [aria-labelledby]="!step1.form.valid||!step1.formemail.valid ? 'disabled_af' : null-->
                <app-add-info-responsable #step2 (next)="onAdd()" [data]="step1.formtype.get('type').value">
                </app-add-info-responsable>
            </mat-step>

            <mat-step [stepControl]="step3.tableForm">
                <ng-template matStepLabel>{{
                    "Informations sur les usines" | translate
                    }}</ng-template>
                <app-table-usine #step3
                                 (next)="onAdd()"
                                 (setProdError)="step4?.setProdError($event)"
                                 [inputData]="{produits: step4?.tableForm, errorMsgProduits: step4?.errorMsg}">
                </app-table-usine>
            </mat-step>
            <mat-step [stepControl]="step4.tableForm">
                <ng-template matStepLabel>{{
                    "Informations sur la classification des produits" | translate
                    }}</ng-template>
                <app-produit-table #step4
                                   (emitError)="step3.erroNext($event)" (next)="onAdd()"
                                   [inputData]="{usine: step3.tableForm, errorMsgUsine: step3?.errorMsg}">
                </app-produit-table>
            </mat-step>

            <mat-step *ngIf="step1.formtype.get('type').value=='TUN'" [stepControl]="step5.tableForm">

                <ng-template matStepLabel>{{
                    "Informations sur les agréments" | translate
                    }}</ng-template>
                <app-agrement-table #agre #step5 (next)="onAdd()"></app-agrement-table>

            </mat-step>

            <mat-step #stepmandai [aria-labelledby]="'mand'" [hasError]="step6?.Ussine.length==0&&stepmandai.interacted"
                      [stepControl]="step6.tableForm "
                      errorMessage="{{'mand_requi'|translate}}">

                <ng-template matStepLabel>{{
                    "Informations sur le mandataire du soumissionnaire" | translate
                    }}</ng-template>
                <app-mandataire-table #step6 (next)="onAddagremment()"
                                      [isetrang]="step1.formtype.get('type').value!='TUN'"></app-mandataire-table>
            </mat-step>
            <mat-step [aria-labelledby]="stepDisabled ? 'disabled_af' : null">
                <ng-template matStepLabel>{{
                    "Conditions_utilisation" | translate
                    }}</ng-template>

                <app-innerhtml
                    #step7
                    [code]="commonCode.InscriptionFournisseur"
                ></app-innerhtml>

                <div fxLayoutAlign="end end" style="padding-top: 2%">
                    <button
                            (click)="
              submit(
                step1.form.getRawValue(),
                step1.formtype.getRawValue(),
                step1.formemail.getRawValue(),
                step3.tableForm.value,
                step2.form.getRawValue(),
                step4.tableForm.value,
                    agre?.tableForm.value,
                step6.tableForm.value
              )
            "
                            [disabled]="step7.accept == 'false'"
                            color="primary"
                            mat-raised-button
                    >
                        <span translate>submit_save</span>
                    </button>
                </div>
            </mat-step>
        </mat-vertical-stepper>
    </mat-card-content>
</app-card>
